var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Rectangle-2_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Types_Water",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6671,
    y1: 61.5343,
    x2: 10.6671,
    y2: 59.1333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A90DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6CBDE4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st0",
    d: "M36,0L36,0c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36l0,0C16.1,72,0,55.9,0,36l0,0 C0,16.1,16.1,0,36,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    className: "st1",
    d: "M21,38.2c-5,0-9.3-3-11.1-7.4c-1-2.3-0.8-4.9,0.3-7.1l9.7-20.3c0.3-0.6,1-0.8,1.6-0.6 C21.8,3,22,3.2,22.1,3.4l9.7,20.3c1.1,2.2,1.2,4.8,0.3,7.1C30.3,35.2,26,38.2,21,38.2z M18.1,30.9c-1.5-0.9-3.1,1.2-1.7,2.3 c0.7,0.5,1.5,0.9,2.6,1.2c0.7,0.2,1.4,0.2,2.2,0.2c2.9,0,5.6-1.3,7.4-3.5h0c-1.8,0.7-3.8,1-5.7,1.1c-1.1,0-2.1-0.1-3.1-0.5 C19.1,31.4,18.6,31.2,18.1,30.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.274b679178e70aaabffad303facc8a32.svg";
export { ForwardRef as ReactComponent };